<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('quran_programs.single_title'),
            subtitle: {
                first_text: $t('quran_programs.title'),
                first_href: '/quran_programs',
                second_text: edu_program ? edu_program.name : ''
            }
        }" />
        <div class="container my-5" v-if="edu_program">
            <div v-for="section in localizedSections" :key="section.key" class="mb-4">
                <h4>{{ section.title }}</h4>
                <div v-html="section.value"></div>
            </div>

        </div>


        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import Home from "../api/home";


export default {
    async created() {
        // let programs = await new Home().QuranPrograms({ per_page: 9, with: ['students'] });
        // this.eduPrograms = programs.data;
        if (this.id) {
            let program = await new Home().QuranProgram(this.id, {});
            this.edu_program = program;
        } else {
            this.$router.push('/quran_programs');
        }
    },
    components: {
        AppFooter, AppNavbar, PagesHero
    },
    data() {
        return {
            id: this.$route.params.id,
            edu_program: null
        }
    },
    computed: {
        localizedSections() {
            const locale = this.$i18n.locale;
            const program = this.edu_program || {};
            const fields = [
                // { key: 'explanation', titleKey: 'quran_programs.explanation' },
                { key: 'vision', titleKey: 'quran_programs.vision' },
                { key: 'message', titleKey: 'quran_programs.message' },
                { key: 'research_fields', titleKey: 'quran_programs.research_fields' },
                { key: 'goals', titleKey: 'quran_programs.goals' },
                { key: 'study_language', titleKey: 'quran_programs.study_language' },
                { key: 'career_horizons', titleKey: 'quran_programs.career_horizons' },
                { key: 'prerequisites', titleKey: 'quran_programs.prerequisites' },
                { key: 'study_results', titleKey: 'quran_programs.study_results' },
            ];

            return fields
                .map(({ key, titleKey }) => {
                    const localizedKey = locale === 'en' ? `${key}_en` : key;
                    const value = program[localizedKey] || '';
                    return {
                        key,
                        title: this.$t(titleKey),
                        value
                    };
                })
                .filter(section => section.value?.trim()); // ✅ Only non-empty
        }
    }


}
</script>

<style scoped>
.row {
    margin-top: 40px;
}

h4 {
    font-size: 28px;
    font-weight: 500;
}

.container>div {
    padding-bottom: 15px;
}
</style>